import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const testimonials = [
  { name: "Moussa Ndiaye", role: "Responsable IT, SENELEC", content: "L'expertise d'ETCS nous a permis de moderniser tout le câblage structuré de notre nouveau siège social. Professionnalisme exemplaire." },
  { name: "Awa Diop", role: "Directrice, Agence Communication", content: "Une équipe réactive qui a su déployer un réseau Wi-Fi stable et performant dans nos bureaux en un temps record." },
];

const SocialProof = () => {
  return (
    <section className="py-16 sm:py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0 }} 
            whileInView={{ opacity: 1 }} 
            viewport={{ once: true, amount: 0.1 }}
            style={{ willChange: 'opacity' }}
            className="text-3xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
            Ils nous font confiance
          </motion.h2>
          <p style={{ color: 'var(--text-secondary)' }}>Retours d'expérience de nos clients partenaires au Sénégal.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.1 }}
              style={{ willChange: 'transform, opacity' }}
              className="p-8 rounded-3xl theme-card relative"
            >
              <Quote className="absolute top-6 right-8 opacity-10" size={40} style={{ color: 'var(--accent-green)' }} />
              <p className="text-lg leading-relaxed mb-6 relative z-10 italic" style={{ color: 'var(--text-primary)' }}>"{t.content}"</p>
              <div>
                <div className="font-bold" style={{ color: 'var(--text-primary)' }}>{t.name}</div>
                <div className="text-sm" style={{ color: 'var(--text-secondary)' }}>{t.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
